'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'thumbs-up';
var width = 512;
var height = 512;
var aliases = [128077,61575];
var unicode = 'f164';
var svgPathData = 'M230.3-6.2l89.2 53.5 6.8 4.1-4.1 6.9c-16.6 27.6-36.9 61.6-61 101.7l218.8 0 0 112-16 0 0 80-16 0 0 64-16 0 0 64-191.1 0-93.5-46.7-19.4-9.7 0 56.5-128 0 0-320 121.2 0c55-91.6 87.7-146.1 98.1-163.5l4.1-6.8 6.9 4.1zM16 464l96 0 0-288-96 0 0 288zM206.3 49.4L128 179.9 128 405.7c7.1 3.6 46 23 116.7 58.3l171.3 0 0-64 16 0 0-64 16 0 0-80 16 0 0-80-231.1 0 7.2-12.1c30.9-51.4 52.3-87.1 64.2-107l-75.4-45.3-22.6 37.8z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faThumbsUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;